import 'slick-carousel/slick/slick.css';
import 'vue-plyr/dist/vue-plyr.css';
import './offline';

window.Vue.component('banner-headline', require('./components/banners/banner-headline'));
window.Vue.component('banner-quiz', require('./components/banners/banner-quiz'));

window.Vue.component('banner-quiz-offline', require('./components/banners/banner-quiz-offline'));
window.Vue.component('banner-list-top', require('./components/banners/banner-list-top'));
window.Vue.component('match-it', require('./components/match-it'));

window.Vue.component('banner-promotions', require('./components/banners/banner-promotions'));
window.Vue.component('onboarding-presentation', require('./components/onboarding-presentation'));
window.Vue.component('onboarding-tutorial-android', require('./components/onboarding-tutorial-android'));
window.Vue.component('onboarding-tutorial-ios', require('./components/onboarding-tutorial-ios'));
window.Vue.component('splashscreen', require('./components/splashscreen.vue'));
window.Vue.component('page-home-index', require('./components/pages/home/index'));

const rootComponents = new Vue({
    el: '#root-home'
});


// WEBPACK FOOTER //
// ./resources/site/js/home.js